import { useState } from "react";
import CoursesTable from "../courses/courses-table";
import SearchInput from "../shared/search-input/search-input";
import { CBHandMessage } from "../shared/CBHandMessage/CBHandMessage";
import { Button, Radio, RadioChangeEvent } from "antd";
import { useNavigate } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
import { useRole } from "../../hooks/user-roles";
import { useDimensions } from "../../hooks/useDimensions";

export default function Courses({ listType }: { listType: string }) {
  const navigate = useNavigate();
  const { width } = useDimensions();
  const [query, setQuery] = useState<string | undefined>("");
  const [option, setOption] = useState<string>("All");
  const { isSuperAdmin, isStudent, user } = useRole();
  const filterOptions = [
    { label: "Courses", value: "Course" },
    { label: "Workshops", value: "Workshop" },
    { label: "All", value: "All" },
  ];

  const searchHandler: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setQuery(e.target.value);
  };

  const onChange = ({ target: { value } }: RadioChangeEvent) => {
    setOption(value);
  };

  const createAsOption = () => {
    navigate(`New-${option}`);
  };

  let message, color;
  if (user?.firstName && listType === "all") {
    color = "gray";
    message =
      "Here is a list of courses you can register for. Go to My Courses to view your registered courses.";
  } else if (user?.firstName && listType === "my") {
    color = "yellow";
    if (isStudent) {
      message =
        "Here is a list of courses you are registered for. Go to All Courses to view courses you can register for.";
    } else {
      message =
        "These are the courses in which you have been assigned a role. Go to All Courses to view all courses.";
    }
  } else {
    color = "yellow";
    message = "Welcome to the SEABC Certificate Program Powered by Class-Bit!";
  }

  return (
    <>
      <div className="pt-4">
        <CBHandMessage color={color}>{message}</CBHandMessage>
      </div>
      <div className="max-w-5xl m-auto">
        <div
          className={`flex ${width >= 500 ? "justify-between" : "justify-center flex-wrap gap-4"} input-container max-w-5xl  m-auto mb-4 pt-4`}
        >
          <div>
            <Radio.Group
              options={filterOptions}
              onChange={onChange}
              value={option}
              optionType="button"
              buttonStyle="solid"
            />
          </div>
          {option !== "All" && isSuperAdmin && (
            <div style={{ width: "10.2rem" }}>
              <Button
                block
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => createAsOption()}
              >
                {option === "Course" ? "New Course" : "New Workshop"}
              </Button>
            </div>
          )}
          <div>
            <SearchInput onSearch={searchHandler} cssClasses="max-w-[180px]" />
          </div>
        </div>
        <div className={`${width <= 500 ? "px-2" : undefined}`}>
          <CoursesTable
            query={query}
            handleChange={option}
            listType={listType}
          ></CoursesTable>
        </div>
      </div>
    </>
  );
}
